import { updateUnitInfo } from "@/service/unit";
export default {
  name: "UpdateUnitName",
  props: {
    visible: {
      type: Boolean,
      default() {
        return false;
      }
    },
    item: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      modal: {
        visible: false,
        loading: false
      },
      formObj: {
        name: ""
      },
      ruleCustom: {
        name: [{
          required: true,
          message: $t("2jb6fo5", "请输入名称")
        }, {
          pattern: /^[a-zA-Z0-9\u4e00-\u9fa5\s+/\\.,;:!?[()\]\\{}_\-\\$€£#@*+&~ ]{2,60}$/,
          message: $t("m65oshn", "仅支持字母数字汉字部分符号2-60个字符的命名")
        }]
      }
    };
  },
  watch: {
    visible(val) {
      val && this.init();
      this.modal.visible = val;
    }
  },
  methods: {
    /* 不显示弹窗 */
    clean() {
      this.$emit("close");
      this.$refs["formCustom"].resetFields();
      this.formObj.name = "";
    },
    init() {
      this.formObj.name = this.item.name;
    },
    /* 提交事件 */
    onCommit() {
      /* 验证 */
      this.$refs["formCustom"].validate(async valid => {
        if (valid) {
          this.modal.loading = true;
          const params = {
            name: this.formObj.name
          };
          let res = await updateUnitInfo(params);
          if (res.data && res.data.result === 0) {
            this.$Message.success($t("d1spvi4", "操作成功"));
            this.$emit("update");
            this.clean();
          }
          this.modal.loading = false;
        }
      });
    }
  }
};